import { Button, Divider, Drawer, Form, FormInstance, Input, message, Modal, Space, Switch, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import { QuestionCircleOutlined, CaretDownOutlined, ReloadOutlined, LineOutlined, SearchOutlined } from '@ant-design/icons';
import EImportFile from "../../../components/eimportfile/EIMSImportFile";
import EAttachment from "../../../components/eattachment/EAtachment";
import TextArea from "antd/lib/input/TextArea";

const ProductMergeEdit = (props: any) => {
    const formRef = useRef<FormInstance>(null);
    const { ...rest } = props;

    const refPrice = useRef<any>(null);
    const refInsurance = useRef<any>(null);
    const refOrder = useRef<any>(null);


    useEffect(() => {
        if (rest.isOpen) {
            switch (rest.viewMode) {
                case 0:
                    setData(null);
                    break;
                case 1:
                    getProductMerge();
                    break;
                case 2:
                    getProductMerge();
                    break;
            }

        } else {
            setData(null);
        }
    }, [rest.isOpen])

    const setData = (record: any) => {
        formRef.current?.resetFields();
        if (record) {
            formRef.current?.setFieldsValue(record);

            if (record.priceAttachment) {
                refPrice.current?.setData(JSON.parse(record.priceAttachment));
            } else {
                refPrice.current?.setData(null);
            }
            if (record.insuranceAttachment) {
                refInsurance.current?.setData(JSON.parse(record.insuranceAttachment));
            } else {
                refInsurance.current?.setData(null);
            }
            if (record.orderAttachment) {
                refOrder.current?.setData(JSON.parse(record.orderAttachment));
            } else {
                refOrder.current?.setData(null);
            }
        }
        else {
            refPrice.current?.setData(null);
            refInsurance.current?.setData(null);
            refOrder.current?.setData(null);
        }
    }

    const getProductMerge = () => {
        if (rest.productMergeID) {
            var params = {
                productMergeID: rest.productMergeID
            };
            Server.Post(URL.ProductMerge.GetProductMerge, params, false).then((response: any) => {
                if (response.isSuccess) {
                    setData(response);
                }
            })
        }
    }

    const handleCancel = () => {
        rest.setIsOpen(false);
    }

    const handleSave = () => {
        formRef.current?.validateFields().then((values => {
            var price = refPrice.current?.getData();
            var insurance = refInsurance.current?.getData();
            var order = refOrder.current?.getData();
            var params = {
                ...values,
                priceAttachment: price,
                insuranceAttachment: insurance,
                orderAttachment: order,
            };
            Server.Post(URL.ProductMerge.SaveProductMerge, params).then((response: any) => {
                if (response.isSuccess) {
                    message.success('保存成功');
                    rest.setIsOpen(false);
                    rest.loadData();
                } else {
                    message.warn(response.returnMsg);
                }
            })
        }));
    }

    return <Drawer title={(rest.viewMode == 0 ? '新增' : '编辑') + "产品库"} width={'50%'} open={rest.isOpen} onClose={handleCancel}
        maskClosable={false}
        bodyStyle={{ padding: 0, margin: 8 }}
        footer={
            <Space style={{ float: 'right' }}>
                <Button onClick={handleSave} type='primary'>保存</Button>
                <Button onClick={handleCancel}>关闭</Button>
            </Space>
        }>
        <Form ref={formRef}
            labelCol={{ flex: '105px' }}
            wrapperCol={{ span: 24 }}
            labelWrap>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />基本信息</div>
            <div style={{ marginLeft: '10px' }} >
                <Form.Item style={{ marginBottom: '5px' }} hidden label={'产品库ID'} name={'productMergeID'} initialValue={null}>
                    <Input readOnly={rest.viewMode == 2} />
                </Form.Item>
                <Form.Item style={{ marginBottom: '5px' }} label={'产品名称'} name={'name'} initialValue={''}
                    rules={[{ required: true, message: '请输入产品名称' }]}>
                    <Input />
                </Form.Item>
                <Form.Item style={{ marginBottom: '5px' }} label={'产品类型'} name={'type'} initialValue={''}
                    rules={[{ required: true, message: '请输入产品类型' }]}>
                    <Input />
                </Form.Item>
                <Form.Item style={{ marginBottom: '5px' }} label={'禁保区域'} name={'unInsuredArea'} initialValue={''}>
                    <Input />
                </Form.Item>
                <Form.Item style={{ marginBottom: '5px' }} label={'备注'} name={'remark'} initialValue={''}>
                    <TextArea rows={5} maxLength={2000} showCount />
                </Form.Item>
                <Form.Item style={{ marginBottom: '5px' }} label={'是否激活'} name={'isActive'} initialValue={true} valuePropName={'checked'}>
                    <Switch checked />
                </Form.Item>
            </div>
            <div className="group"><LineOutlined rotate={90} style={{ color: '#1890ff' }} />附件信息</div>
            <div style={{ marginLeft: '10px' }} >
                <EAttachment label={'价格表'} name="url" viewMode={0} formRef={formRef} ref={refPrice} />
                <EAttachment label={'投保单'} name="url" viewMode={0} formRef={formRef} ref={refInsurance} />
                <EAttachment label={'保单样板'} name="url" viewMode={0} formRef={formRef} ref={refOrder} />
            </div>
        </Form>
    </Drawer>
};
export default ProductMergeEdit